<template>
  <v-dialog v-model="visible" max-width="1200px">
    <v-card style="overflow-y: hidden">
      <v-card-title class="py-2 px-4">{{ titulo }}</v-card-title>

      <v-divider class="my-0"></v-divider>

      <v-card-text class="pa-4">
        <v-form>
          <v-row>
            <v-col cols="12" md="4" lg="6">
              <v-select
                v-model="form.sedeUniversidadId"
                :items="sedesUniversidades"
                item-text="nombre"
                item-value="id"
                label="Sede Universidad"
                outlined
                dense
                hide-details
                clearable
                @change="obtenerAreasYCategoriasUniversidadesYPlanesPagos">
                <template v-slot:item="{ item }">
                  <v-list-item-content>
                    <v-list-item-title class="font-weight-medium">{{ item.nombre }}</v-list-item-title>
                    <v-list-item-subtitle class="subtitle-2 text-uppercase">
                      <small>{{ item.institucion.nombre }}</small>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </template>
              </v-select>

              <small v-for="error in errores.sedeUniversidadId" :key="error" class="d-inline-block text-danger">
                {{ error }}
              </small>
            </v-col>

            <v-col cols="12" lg="6" />

            <v-col cols="12" md="4" lg="3">
              <v-text-field v-model="form.codigo" label="Código" outlined dense hide-details clearable></v-text-field>

              <small v-for="error in errores.codigo" :key="error" class="d-inline-block text-danger">{{ error }}</small>
            </v-col>

            <v-col cols="12" md="8" lg="7">
              <v-text-field
                v-model="form.programaNombre"
                label="Programa"
                outlined
                dense
                hide-details
                clearable></v-text-field>

              <small v-for="error in errores.programaNombre" :key="error" class="d-inline-block text-danger">
                {{ error }}
              </small>
            </v-col>

            <v-col cols="12" md="4" lg="2">
              <v-text-field
                v-model="form.version"
                type="text"
                label="Versión"
                outlined
                dense
                hide-details
                clearable></v-text-field>

              <small v-for="error in errores.version" :key="error" class="d-inline-block text-danger">
                {{ error }}
              </small>
            </v-col>

            <v-col cols="12" md="4" lg="4">
              <v-select
                v-model="form.areaUniversidadId"
                :items="areasUniversidades"
                label="Área"
                outlined
                dense
                hide-details
                item-text="nombreTipo"
                item-value="id"
                clearable
                :disabled="areasUniversidades.length == 0">
                <template #item="{ item }">
                  <v-list-item-content>
                    <v-list-item-title>{{ item.nombre }}</v-list-item-title>
                    <v-list-item-subtitle>
                      <small>{{ item.tipo.toUpperCase() }}</small>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </template>
              </v-select>

              <small v-for="error in errores.areaUniversidadId" :key="error" class="d-inline-block text-danger">{{
                error
              }}</small>
            </v-col>

            <v-col cols="12" md="4" lg="4">
              <v-select
                v-model="form.categoriaUniversidadId"
                :items="categoriasUniversidades"
                label="Tipo"
                outlined
                dense
                hide-details
                item-text="nombre"
                item-value="id"
                clearable
                :disabled="categoriasUniversidades.length == 0"></v-select>

              <small v-for="error in errores.categoriaUniversidadId" :key="error" class="d-inline-block text-danger">
                {{ error }}
              </small>
            </v-col>

            <v-col cols="12" md="4" lg="2">
              <v-select
                v-model="form.gestion"
                :items="gestiones"
                label="Gestión"
                outlined
                dense
                hide-details
                item-text="gestion"
                item-value="gestion"
                clearable></v-select>

              <small v-for="error in errores.gestion" :key="error" class="d-inline-block text-danger">
                {{ error }}
              </small>
            </v-col>

            <v-col cols="12" md="4" lg="2">
              <v-text-field
                v-model="form.grupo"
                type="number"
                min="1"
                label="Grupo"
                outlined
                dense
                hide-details
                clearable></v-text-field>

              <small v-for="error in errores.grupo" :key="error" class="d-inline-block text-danger">
                {{ error }}
              </small>
            </v-col>

            <v-col cols="12" md="4" lg="3">
              <v-text-field
                v-model="form.resolucionAprobacionUniversidad"
                label="Resolución Aprobación Universidad"
                outlined
                dense
                hide-details
                clearable></v-text-field>

              <small
                v-for="error in errores.resolucionAprobacionUniversidad"
                :key="error"
                class="d-inline-block text-danger">
                {{ error }}
              </small>
            </v-col>

            <v-col cols="12" md="4" lg="3">
              <v-menu
                ref="menuFechaInicioRef"
                v-model="menuFechaInicio"
                transition="scale-transition"
                :close-on-content-click="false"
                offset-y
                min-width="auto">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="form.fechaInicio"
                    label="Fecha Inicio"
                    prepend-icon="mdi-calendar"
                    outlined
                    dense
                    hide-details
                    readonly
                    clearable
                    v-bind="attrs"
                    v-on="on"></v-text-field>
                </template>

                <v-date-picker v-model="form.fechaInicio" no-title scrollable @input="menuFechaInicio = false">
                  <v-spacer></v-spacer>

                  <v-btn text color="primary" @click="menu = menuFechaInicio"> Cancelar </v-btn>

                  <v-btn text color="primary" @click="$refs.menuFechaInicioRef.save(form.fechaInicio)"> Aceptar </v-btn>
                </v-date-picker>
              </v-menu>

              <small v-for="error in errores.fechaInicio" :key="error" class="d-inline-block text-danger">
                {{ error }}
              </small>
            </v-col>

            <v-col cols="12" md="4" lg="3">
              <v-menu
                ref="menuFechaFinRef"
                v-model="menuFechaFin"
                transition="scale-transition"
                :close-on-content-click="false"
                offset-y
                min-width="auto">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="form.fechaFin"
                    label="Fecha Fin"
                    prepend-icon="mdi-calendar"
                    outlined
                    dense
                    hide-details
                    readonly
                    clearable
                    v-bind="attrs"
                    v-on="on"></v-text-field>
                </template>

                <v-date-picker v-model="form.fechaFin" no-title scrollable @input="menuFechaFin = false">
                  <v-spacer></v-spacer>

                  <v-btn text color="primary" @click="menu = menuFechaFin"> Cancelar </v-btn>

                  <v-btn text color="primary" @click="$refs.menuFechaFinRef.save(form.fechaFin)"> Aceptar </v-btn>
                </v-date-picker>
              </v-menu>

              <small v-for="error in errores.fechaFin" :key="error" class="d-inline-block text-danger">
                {{ error }}
              </small>
            </v-col>

            <v-col cols="12" md="4" lg="3">
              <v-menu
                ref="menuFechaInscripcionRef"
                v-model="menuFechaInscripcion"
                transition="scale-transition"
                :close-on-content-click="false"
                offset-y
                min-width="auto">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="form.fechaInscripcion"
                    label="Fecha Inscripción"
                    prepend-icon="mdi-calendar"
                    outlined
                    dense
                    hide-details
                    readonly
                    clearable
                    v-bind="attrs"
                    v-on="on"></v-text-field>
                </template>

                <v-date-picker
                  v-model="form.fechaInscripcion"
                  no-title
                  scrollable
                  @input="menuFechaInscripcion = false">
                  <v-spacer></v-spacer>

                  <v-btn text color="primary" @click="menu = menuFechaInscripcion"> Cancelar </v-btn>

                  <v-btn text color="primary" @click="$refs.menuFechaInscripcionRef.save(form.fechaInscripcion)">
                    Aceptar
                  </v-btn>
                </v-date-picker>
              </v-menu>

              <small v-for="error in errores.fechaInscripcion" :key="error" class="d-inline-block text-danger">
                {{ error }}
              </small>
            </v-col>

            <v-col cols="12">
              <vue-select
                v-model="form.planPagoUniversidadId"
                class="style-chooser"
                placeholder="Seleccione un Plan de Pago"
                :options="planesPagosUniversidades"
                label="nombre"
                :append-to-body="true"
                :reduce="(option) => option.id"
                clearable
                :disabled="planesPagosUniversidades.length == 0">
                <template #option="{ nombre, planesPagosConceptosUniversidades }">
                  <div style="padding-bottom: 0.5rem">
                    <strong style="display: block; font-size: 1.125rem">{{ nombre }}</strong>

                    <TablaPlanesPagosConceptosUniversidades
                      :planesPagosConceptosUniversidades="planesPagosConceptosUniversidades" />
                  </div>
                </template>
              </vue-select>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-divider class="my-0"></v-divider>

      <v-card-actions>
        <v-btn color="blue darken-1" :disabled="enviando" text @click.prevent="cerrar"> Cerrar </v-btn>

        <v-btn
          color="blue darken-1"
          :disabled="enviando"
          :loading="enviando"
          text
          @click.prevent="validar(registrar, editar)">
          Guardar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import 'vue-select/dist/vue-select.css';
import ProgramaUniversidadService from '../services/programa-universidad.service';
import SedeUniversidadService from '../services/sede-universidad.service';
import CategoriaUniversidadService from '../services/categoria-universidad.service';
import AreaUniversidadService from '../services/area-universidad.service';
import modalFormMixin from '../mixins/modal-form.mixin';
import apiConsumerMixin from '../mixins/api-consumer.mixin';
import GestionService from '../services/gestion.service';
import PlanPagoUniversidadService from '../services/plan-pago-universidad.service';
import TablaPlanesPagosConceptosUniversidades from './TablaPlanesPagosConceptosUniversidades.vue';

export default {
  name: 'ModalFormularioProgramaUniversidad',
  mixins: [modalFormMixin, apiConsumerMixin],
  components: {
    TablaPlanesPagosConceptosUniversidades,
  },
  data() {
    return {
      categorias: [],
      areasUniversidadesSinMapeo: [],
      areasUniversidades: [],
      categoriasUniversidades: [],
      sedesUniversidades: [],
      planesPagosUniversidades: [],
      menuFechaInicio: false,
      menuFechaFin: false,
      menuFechaInscripcion: false,
      gestiones: [],
    };
  },
  watch: {
    'form.codigo': function () {
      this.errores.codigo = [];
    },
    'form.programaNombre': function () {
      this.errores.programaNombre = [];
    },
    'form.gestion': function () {
      this.errores.gestion = [];
    },
    'form.resolucionAprobacionUniversidad': function () {
      this.errores.resolucionAprobacionUniversidad = [];
    },
    'form.version': function () {
      this.errores.version = [];
    },
    'form.areaUniversidadId': function () {
      this.errores.areaUniversidadId = [];
    },
    'form.fechaInicio': function () {
      this.errores.fechaInicio = [];
    },
    'form.fechaFin': function () {
      this.errores.fechaFin = [];
    },
    'form.categoriaUniversidadId': function () {
      this.errores.categoriaUniversidadId = [];
    },
    'form.fechaInscripcion': function () {
      this.errores.fechaInscripcion = [];
    },
    'form.sedeUniversidadId': function () {
      this.errores.sedeUniversidadId = [];
    },
    'form.grupo': function () {
      this.errores.grupo = [];
    },
    'form.planPagoUniversidadId': function () {
      this.errores.planPagoUniversidadId = [];
    },
  },
  methods: {
    generarObjetoFormRegistrar() {
      return {
        id: null,
        codigo: null,
        programaNombre: null,
        gestion: null,
        resolucionAprobacionUniversidad: null,
        version: null,
        areaUniversidadId: null,
        fechaInicio: null,
        fechaFin: null,
        estado: null,
        categoriaUniversidadId: null,
        fechaInscripcion: null,
        sedeUniversidadId: null,
        grupo: null,
        planPagoUniversidadId: null,
      };
    },
    generarObjetoFormEditar(data) {
      return {
        id: data.id,
        codigo: data.codigo,
        programaNombre: data.programaNombre,
        gestion: data.gestion,
        resolucionAprobacionUniversidad: data.resolucionAprobacionUniversidad,
        version: data.version,
        areaUniversidadId: data.areaUniversidadId,
        fechaInicio: data.fechaInicio,
        fechaFin: data.fechaFin,
        estado: data.estado,
        categoriaUniversidadId: data.categoriaUniversidadId,
        fechaInscripcion: data.fechaInscripcion,
        sedeUniversidadId: data.sedeUniversidadId,
        grupo: data.grupo,
        planPagoUniversidadId: data.planPagoUniversidadId,
      };
    },
    async obtenerAreasUniversidades(sedeUniversidadId) {
      this.areasUniversidades = [];

      if (!sedeUniversidadId) {
        return;
      }

      const sedeUniversidad = this.sedesUniversidades.find((sede) => sede.id == sedeUniversidadId);

      if (!sedeUniversidad) {
        return;
      }

      const params = {
        universidadId: sedeUniversidad.universidadId,
      };

      await this.obtenerDatosMixin(
        AreaUniversidadService.findAll,
        'areasUniversidadesSinMapeo',
        params,
        () => {},
        () => {
          this.areasUniversidades = this.areasUniversidadesSinMapeo.map((area) => ({
            id: area.id,
            nombre: area.nombre,
            tipo: area.tipo,
            nombreTipo: `${area.nombre} (${area.tipo.toUpperCase()})`,
          }));
        },
      );
    },
    async obtenerCategoriasUniversidades(sedeUniversidadId) {
      this.categoriasUniversidades = [];

      if (!sedeUniversidadId) {
        return;
      }

      const sedeUniversidad = this.sedesUniversidades.find((sede) => sede.id == sedeUniversidadId);

      if (!sedeUniversidad) {
        return;
      }

      const params = {
        universidadId: sedeUniversidad.universidadId,
      };

      await this.obtenerDatosMixin(CategoriaUniversidadService.findAll, 'categoriasUniversidades', params);
    },
    async obtenerAreasYCategoriasUniversidades(sedeUniversidadId) {
      await this.obtenerAreasUniversidades(sedeUniversidadId);
      await this.obtenerCategoriasUniversidades(sedeUniversidadId);
    },
    async obtenerAreasYCategoriasUniversidadesYPlanesPagos(sedeUniversidadId) {
      await this.obtenerAreasYCategoriasUniversidades(sedeUniversidadId);
      await this.obtenerPlanesPagosUniversidades(sedeUniversidadId);
    },
    async obtenerSedesUniversidades() {
      await this.obtenerDatosMixin(SedeUniversidadService.findAll, 'sedesUniversidades', {
        sedeId: this.$store.state.CARGO.id == 1 ? null : this.$store.state.CARGO.sede.id,
      });
    },
    async obtenerGestiones() {
      await this.obtenerDatosMixin(GestionService.findAll, 'gestiones');
    },
    async obtenerPlanesPagosUniversidades(sedeUniversidadId) {
      this.planesPagosUniversidades = [];

      if (!sedeUniversidadId) {
        return;
      }

      const sedeUniversidad = this.sedesUniversidades.find((sede) => sede.id == sedeUniversidadId);

      if (!sedeUniversidad) {
        return;
      }

      const params = {
        universidadId: sedeUniversidad.universidadId,
      };

      await this.obtenerDatosMixin(PlanPagoUniversidadService.findAll, 'planesPagosUniversidades', params);
    },
    abrir(accion, data = []) {
      this.obtenerSedesUniversidades().then(() => {
        if (accion == this.accionesCrud.EDITAR) {
          Promise.all([
            this.obtenerAreasYCategoriasUniversidadesYPlanesPagos(data?.sedeUniversidadId),
            this.obtenerGestiones(),
          ]).then(() => {
            this.abrirMixin(accion, data);
          });
        } else {
          Promise.all([this.obtenerGestiones()]).then(() => {
            this.abrirMixin(accion, data);
          });
        }
      });
    },
    async registrar() {
      this.guardar(this.accionesCrud.REGISTRAR);
    },
    async editar() {
      this.guardar(this.accionesCrud.EDITAR);
    },
    async guardar(accion) {
      this.guardarDatosMixin(
        ProgramaUniversidadService.create,
        ProgramaUniversidadService.update,
        accion,
        this.form,
        this.nombreRecurso,
        () => {
          this.areasUniversidades = [];
          this.categoriasUniversidades = [];
          this.$emit('actualizarListado');
          this.cerrar();
        },
        (errores) => {
          this.errores = errores;
        },
      );
    },
  },
};
</script>

<style scoped>
::v-deep .v-select.v-text-field--outlined:not(.v-text-field--single-line).v-input--dense .v-select__selections {
  padding: 0px 0;
}

::v-deep .v-text-field .v-input__control .v-input__slot {
  min-height: auto !important;
  display: flex !important;
  align-items: center !important;
}

::v-deep .v-text-field--outlined.v-input--dense .v-label {
  top: 5px;
}

::v-deep .v-text-field .v-label {
  font-weight: 400;
}
</style>